import React from "react";
import classNames from "classnames";
import { Button, Card, Col, Row, Typography } from "@payping/web-components";
import { CheckOutlined, CopyOutlined } from "@payping/icons";
import { useNavigate } from "react-router-dom";
import { webConstants } from "@payping/utils/platformConstants";

import { safeJoinPath } from "@payping/utils/string";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/SummationTab.module.scss";
import { referralOverviewCardId, referralOverviewLinkId } from "@/assets/googleTrackIds";
import specificStyles from "./styles.module.scss";

interface Props {
  isReferralActive?: boolean;
  referralCode?: string;
}

const ProfileCompletion: React.FC<Props> = ({ referralCode, isReferralActive }) => {
  // =========================================
  // Init
  // =========================================
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  // =========================================
  // Render
  // =========================================
  return (
    <Card.Raw className={styles.container}>
      <Card.Raw.ColMeta
        className={classNames(!isReferralActive && specificStyles.blurred)}
        header={<Card.Raw.RowMeta title={t("overview.paypingReferral")} />}
      >
        <Row
          className={classNames(styles.profileCompletionProgress, "w-100")}
          justify={"space-between"}
          align={"middle"}
        >
          <Col>
            <Typography.Text>{t("overview.referralLink")}</Typography.Text>
          </Col>
          <Col>
            <Typography.Text
              copyable={{
                icon: [
                  <CopyOutlined data-google-track={referralOverviewLinkId} key={0} width={"18px"} height={"18px"} />,
                  <CheckOutlined key={1} width={"14px"} height={"14px"} />,
                ],
                text: safeJoinPath(webConstants.PPNG, "r", referralCode || ""),
              }}
            >
              {safeJoinPath(webConstants.PPNG, "r", referralCode || "")}
            </Typography.Text>
          </Col>
        </Row>
      </Card.Raw.ColMeta>
      {!isReferralActive && (
        <Card.Raw.ColMeta
          className={specificStyles.overlay}
          header={<Card.Raw.RowMeta className="color--cta" title={t("overview.paypingReferral")} />}
        >
          <Row
            className={classNames(styles.profileCompletionProgress, "w-100")}
            justify={"space-between"}
            align={"middle"}
          >
            <Col span={24}>
              <Row className="w-100" justify={"center"}>
                <Button
                  data-google-track={referralOverviewCardId}
                  block
                  variant={"primary"}
                  ghost
                  className={specificStyles.button}
                  onClick={() => navigate(webConstants.DashboardRoutes.user.referral)}
                >
                  {t("overview.referralCodePreview")}
                </Button>
              </Row>
            </Col>
          </Row>
        </Card.Raw.ColMeta>
      )}
    </Card.Raw>
  );
};

export default ProfileCompletion;
